import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, LogIn, Loader2, ArrowLeft } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { login as apiLogin } from "../api";
import { toast } from "../hooks/use-toast";

const BB_LOGO = "https://customer-assets-m6fa6gv7.emergentagent.net/job_parceiros-bb-digital/artifacts/jxz0vlm8_icon-logo-bb-100.png";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = await apiLogin(username, password);
      localStorage.setItem("bb_admin_token", token);
      navigate("/admin/dashboard");
    } catch (err) {
      toast({ title: "Acesso negado", description: "Usuário ou senha incorretos.", variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-br from-[#0A1B6B] via-[#465EFF] to-[#0A1B6B] px-5">
      {/* BB logo watermark (user-provided asset) */}
      <img
        src={BB_LOGO}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 w-[520px] max-w-[130%] -translate-x-1/2 -translate-y-1/2 opacity-[0.08] brightness-0 invert"
      />
      <div className="relative w-full max-w-md">
        <div className="rounded-2xl bg-white p-8 shadow-2xl">
          <div className="mb-6 flex flex-col items-center text-center">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#465EFF]/10">
              <Lock className="h-6 w-6 text-[#465EFF]" />
            </div>
            <h1 className="mt-3 font-heading text-xl font-extrabold text-[#0A1B6B]">Área Administrativa
            </h1>
            <p className="text-sm text-slate-400">Acesse para gerenciar os cadastros</p>
          </div>
          <form onSubmit={handleLogin} className="flex flex-col gap-4">
            <div className="flex flex-col gap-1.5">
              <Label className="text-sm font-medium text-slate-700">Usuário</Label>
              <Input value={username} onChange={(e) => setUsername(e.target.value)} placeholder="admin" />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label className="text-sm font-medium text-slate-700">Senha</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            <Button type="submit" disabled={loading} className="mt-2 bg-[#465EFF] text-white hover:bg-[#3448d6]">
              {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <LogIn className="mr-2 h-4 w-4" />}
              Entrar
            </Button>
          </form>
          <button
            onClick={() => navigate("/")}
            className="mt-5 flex w-full items-center justify-center gap-1.5 text-xs font-medium text-slate-400 hover:text-[#465EFF]"
          >
            <ArrowLeft className="h-3 w-3" /> Voltar ao site
          </button>
        </div>
      </div>
    </div>
  );
}
